import { Offer, CarlineWithOffers, OfferEquipments } from './types';

export const fakeEquipamiento = { equipamiento: { titulo: '', descripcion: '', icono: '' } };

export const fakeOfferEquipment: OfferEquipments = {
  serie: [],
  promocional: [],
  destacados: [],
};

export const fakeOffer: Offer = {
  anchor: '',
  activo: 1,
  carlineCode: null,
  carlineName: '',
  carlineText: '',
  carlineTitle: '',
  colores: {
    exterior: {
      nombre: '',
      codigo: '',
      hexadecimal: '',
      invertido: true,
      atrevido: true,
      elegante: true,
    },
  },
  cuota: null,
  cuotaInfo: '',
  cuotaText: '',
  cuotaTipo: '',
  dco: null,
  descripcion: '',
  equipamientos: fakeOfferEquipment,
  financiacionName: '',
  financiacionText: '',
  id: null,
  infoCuota: '',
  legal: '',
  mediaAssets: { CarSideview: '' },
  modalidad: '',
  motorizacion: '',
  myRenting: true,
  ncuotas: null,
  next: true,
  ourRenting: true,
  precio: null,
  precioText: '',
  prioridad: 1,
};

export const fakeOffer2 = Object.assign({}, fakeOffer);
fakeOffer2.prioridad = 0;

export const fakeCarlineWithOffers: CarlineWithOffers = {
  activo: false,
  activoMatch: false,
  activoMeasurements: false,
  activoOffers: false,
  capacidadMaletero: [],
  categorias: {},
  code: 0,
  colores: {
    exterior: { nombre: '', codigo: '', hexadecimal: '', invertido: false, atrevido: false, elegante: false },
  },
  id: 10000000,
  legalConsumos: '',
  mediaAssets: { CarSideview: '' },
  medidas: {},
  name: '',
  nuevo: false,
  ofertas: [fakeOffer, fakeOffer, fakeOffer2],
  plazas: 0,
  showroomURL: '',
  text: '',
  title: '',
};
